import { capitalize } from "lodash-es";

/** Human-readable label for API enum strings (e.g. `IN_HOUSE` → "In house"). */
export function formatEnumLabel(value: string | null | undefined): string {
  if (!value) return "";
  return capitalize(value.replaceAll("_", " ").toLowerCase());
}
